import axios from "axios";
import React, { Component } from "react";
import { TableContainer } from "./TableContainer";

const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

class MainTable extends Component {
  state = {
    data: [],
    displayedData: [],
    isLoading: true,
  };

  refreshState() {
    console.log("refresh");
    this.loadData();
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    this.setState({ isLoading: true });

    try {
      const response = await this.callApi();
      this.setData(response);
    } catch (err) {
      console.log(err);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  setData = (res) => {
    const enrichedData = this.props.enrich(res.data);
    // console.log(enrichedData);
    this.setState({ displayedData: enrichedData });
  };

  callApi = async () => {
    if (this.props.request) {
      const response = await axios.post(this.props.path, this.props.request);
      return response;
    } else {
      const response = await axios.get(this.props.path);
      return response;
    }
  };

  csvOnClickHandler = async (event) => {
    console.log("csvOnClickHandler");
    this.props.csvOnClickHandler(event);
    await sleep(1000);
    this.refreshState();
  };

  render() {
    return (
      <div className={this.props.divClassName}>
        <section id="main-content">
          <TableContainer
            columns={this.props.columns(() => this.refreshState())}
            data={this.state.displayedData}
            tableName={this.props.tableName}
            needAggregate={this.props.needAggregate}
            aggregatePanel={this.props.aggregatePanel}
            newObjectLabel={this.props.newObjectLabel}
            dialogContent={this.props.dialogContent}
            refreshState={() => this.refreshState()}
            cookieObjects={this.props.cookieObjects}
            dialogSize={this.props.dialogSize}
            updateRows={this.updateRows}
            csvOnChangeHandler={this.props.csvOnChangeHandler}
            csvOnClickHandler={(event) => this.csvOnClickHandler(event)}
            syncInvoices={this.props.syncInvoices}
            isLoading={this.state.isLoading}
          />
        </section>
      </div>
    );
  }
}

export default MainTable;
